__turbopack_context__.v({
  "About": "Nt6YTG_About",
  "AboutItem": "Nt6YTG_AboutItem",
  "AllowOverflow": "Nt6YTG_AllowOverflow",
  "BlueGreen": "Nt6YTG_BlueGreen",
  "BlurbContainer": "Nt6YTG_BlurbContainer",
  "Blurbs": "Nt6YTG_Blurbs",
  "Contact": "Nt6YTG_Contact",
  "ContactLinks": "Nt6YTG_ContactLinks",
  "Container": "Nt6YTG_Container",
  "Divider": "Nt6YTG_Divider",
  "DividerContainer": "Nt6YTG_DividerContainer",
  "Email": "Nt6YTG_Email",
  "EventSubmissionPage": "Nt6YTG_EventSubmissionPage",
  "Gradient": "Nt6YTG_Gradient",
  "HomePage": "Nt6YTG_HomePage",
  "LandingPage": "Nt6YTG_LandingPage",
  "Logo": "Nt6YTG_Logo",
  "LogoContainer": "Nt6YTG_LogoContainer",
  "NoBg": "Nt6YTG_NoBg",
  "Phone": "Nt6YTG_Phone",
  "PinkBlue": "Nt6YTG_PinkBlue",
  "PinkOrange": "Nt6YTG_PinkOrange",
  "PinkPurple": "Nt6YTG_PinkPurple",
  "PlattanDesktop": "Nt6YTG_PlattanDesktop",
  "PlattanMobile": "Nt6YTG_PlattanMobile",
  "PurpleBlue": "Nt6YTG_PurpleBlue",
  "RichTextPage": "Nt6YTG_RichTextPage",
  "Root": "Nt6YTG_Root",
  "Title": "Nt6YTG_Title",
  "Video": "Nt6YTG_Video",
  "White": "Nt6YTG_White",
});
